<template>
  <div class="td-admin-container">
    <CustomDialog
      :visible="showDialog"
      @confirm="changeStatus"
      @close="showDialog = false"
      :title="dialogTitle"
    >
      <template v-slot:body>
        <el-input type="textarea" class="input" placeholder="Reference" v-model="reference" />
        <span class="error-message">{{ errorMessage }}</span>
      </template>
    </CustomDialog>

    <table class="striped">
      <thead>
      <tr>
        <th>Client ID</th>
        <th>Login</th>
        <th>Name</th>
        <th>Transfer ID</th>
        <th>From Account</th>
        <th>IBAN</th>
        <th>Beneficiary Reference</th>
        <th>Pay Charges</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
      </thead>

      <tbody>
      <PaymentRequestRow
        v-for="(item, index) in transfer_list"
        :key="item.id"
        :item=item
        @ReloadBeneficiaryTransferList="loadTransfers()"
        @openDialog="openDialog"
        :class="{'greyRow': index % 2 === 0}"
      />
      </tbody>
    </table>
  </div>
</template>

<script>

  import PaymentRequestRow from "./PaymentRequestRow";
  import CustomDialog from "../CustomDialog";

  export default {
    data: () => ({
      transfer_list: [],
      showDialog: false,
      reference: null,
      dialogTitle: null,
      transfer: null,
      status: null,
      errorMessage: null,
    }),

    async mounted() {
      await this.loadTransfers();
    },

    methods: {
      openDialog({ status, transfer }) {
        if (status === 3) this.dialogTitle = 'Confirmed'
        else this.dialogTitle = 'Canceled'

        this.reference = null
        this.transfer = transfer
        this.status = status
        this.showDialog = true
      },

      async loadTransfers() {
        this.transfer_list = await this.$store.dispatch('request', {
          path: 'admin/gets/beneficiaries/transfers/lists', body: {}
        })
      },

      async changeStatus() {
        if (!this.reference) {
          this.errorMessage = 'The field must be filled'
          return
        }

        await this.$store.dispatch('request', {
          path: 'admin/changes/beneficiaries/transfers/statuses', body: {
            transfer: this.transfer,
            reference: this.reference,
            status: this.status,
          }
        });

        this.errorMessage = null
        this.showDialog = false
        this.transfer = false
        this.reference = false
        this.status = false
        await this.loadTransfers()
      }
    },
    components: {
      PaymentRequestRow,
      CustomDialog,
    },

  }
</script>

<style lang="scss" scoped>

  .error-message {
    color: #cc3f55;
    font-size: 14px;
  }

  .greyRow {
    background-color: rgba(211,211,211, 0.8) !important;
  }
</style>
